import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import {
  FontWeights,
  IconButton,
  IContextualMenuItem,
  mergeStyles,
  Stack,
  Text,
  TooltipHost,
  useTheme
} from "@bps/fluent-ui";
import { PatientNotice } from "@stores/practice/models/PatientNotice.ts";
import { PatientNoticeTypeText } from "@ui-components/RefText.tsx";

import { colorDotPrefixStyles, getPriorityColor } from "./utils.ts";

interface PatientNoticesTableRowProps {
  showActions: undefined | boolean;
  items: IContextualMenuItem[];
  patientNotice: PatientNotice;
}

export const PatientNoticesTableRow: FunctionComponent<PatientNoticesTableRowProps> =
  observer(({ showActions, items, patientNotice }) => {
    const { palette } = useTheme();

    return (
      <Stack
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: 4 }}
        styles={{
          root: {
            width: "100%",
            position: "relative" // Fix for issue where tooltip hover causes scrollbar
          }
        }}
      >
        <Stack.Item styles={{ root: { marginRight: "4px" } }}>
          <div
            className={mergeStyles(
              colorDotPrefixStyles(
                getPriorityColor(palette, patientNotice.priority)
              )
            )}
          />
        </Stack.Item>
        <Stack.Item
          styles={{
            root: {
              marginRight: "auto",
              color: palette.themeDarker,
              fontWeight: FontWeights.semibold
            }
          }}
        >
          <PatientNoticeTypeText code={patientNotice.type} separator=" " />
          <Text styles={{ root: { wordBreak: "break-word" } }}>
            {patientNotice.comment && ` - ${patientNotice.comment}`}
          </Text>
        </Stack.Item>

        {showActions && (
          <TooltipHost content="More">
            <IconButton
              menuIconProps={{ iconName: "More" }}
              menuProps={{ items }}
            />
          </TooltipHost>
        )}
      </Stack>
    );
  });
